import Staking from "./Staking";

const Stake = () => {
  return (
    <Staking></Staking>
  );
};

export default Stake;